import { WithId } from "@/typeUtils"
import { IPageData, IPageParams } from "../types"
import { E_ModelPartial } from "./model.types"
import { IAlarmDetail } from "./alarm.types"
import { E_Axis } from "./sensor.types"
import _ from "lodash"
import { E_UpkeepRepairHandleStatus } from "@/spot_check/api/modules/types"

/**
 * 算法名称
 */
export enum E_AlgorithmName {
    UML_SelfDiagnosis = 'UML_SelfDiagnosis',
    Bearing_SelfDiagnosis_1 = 'Bearing_SelfDiagnosis_1',
    SidebandFaults_Category_1 = 'SidebandFaults_Category_1',
    TimeDomainImpulse_Category_1 = 'TimeDomainImpulse_Category_1',

    Bearing_SelfDiagnosis_2 = 'Bearing_SelfDiagnosis_2',
    SidebandFaults_Category_2 = 'SidebandFaults_Category_2',
    TimeDomainImpulse_Category_2 = 'TimeDomainImpulse_Category_2',

    /**
     * 转子类
     */
    UML_SelfDiagnosis_25H='UML_SelfDiagnosis_25H',
    /**
     * 滚动轴承
     */
    Bearing_SelfDiagnosis_25H_1 = 'Bearing_SelfDiagnosis_25H_1',
    SideBand_SelfDiagnosis_25H_1 = 'SideBand_SelfDiagnosis_25H_1',
    ImpulseFault_SelfDiagnosis_25H_1 = 'ImpulseFault_SelfDiagnosis_25H_1',
    /**
     * 齿轮箱故障
     */
    Bearing_SelfDiagnosis_25H_2 = 'Bearing_SelfDiagnosis_25H_2',
    SideBand_SelfDiagnosis_25H_2 = 'SideBand_SelfDiagnosis_25H_2',
    ImpulseFault_SelfDiagnosis_25H_2 = 'ImpulseFault_SelfDiagnosis_25H_2',
}

/**
 * 故障类型	
 * $t('enum.E_ModelFaultType.LooseFoundation')
 * $t('enum.E_ModelFaultType.Imbalance')
 * $t('enum.E_ModelFaultType.WrongCenter')
 * $t('enum.E_ModelFaultType.WearAndTear')
 * $t('enum.E_ModelFaultType.BearingFailure')
 * $t('enum.E_ModelFaultType.GearFailure')
 * $t('enum.E_ModelFaultType.NoRotorFailure')
 * $t('enum.E_ModelFaultType.NoBearingFailure')
 * $t('enum.E_ModelFaultType.NoGearFailure')
 * $t('enum.E_ModelFaultType.NotError')
 * $t('enum.E_ModelFaultType.DownTimeData')
 * $t('enum.E_ModelFaultType.NoWave')
 * 
 * $t('enum.E_ModelFaultType.Durability')
 */
export enum E_ModelFaultType {
    /**
    *基础松动
     */
    LooseFoundation = '11',
    /**
     * 不平衡,
     */
    Imbalance = '12',
    /**
     * 不对中,
     */
    WrongCenter = '13',

    /**
    磨损松动
     */
    WearAndTear = '14',

    /**
     * 轴承故障,
     */
    BearingFailure = '16',
    /**
     * 齿轮故障,
     */
    GearFailure = '17',

    /**
     * 无转子故障,
     */
    NoRotorFailure = '10',

    /**
     * 无轴承故障,
     */
    NoBearingFailure = '15',
    /**
     * 无齿轮故障,
     */
    NoGearFailure = '18',


    /**
     * 故障预测
     */
    Durability = '19',

    /**
     * 停机数据
     */
    DownTimeData = '20',

    /**
     *  无波形
     */
    NoWave = '21',

    /**
     * 无明显异常
     */
    NotError = '1000',
}

export const E_ModelFaultType_Invert = _.invert(E_ModelFaultType)

/***
 * 诊断结果类型展示
 * $t('enum.E_ModelFaultTypeKind.RotorFailure')
 * $t('enum.E_ModelFaultTypeKind.BearingFailure')
 * $t('enum.E_ModelFaultTypeKind.GearFailure')
 * $t('enum.E_ModelFaultTypeKind.Durability')
 * $t('enum.E_ModelFaultTypeKind.GearBearingFailure')
 * 
 * $t('enum.E_ModelFaultTypeKind.DownTimeData')
 * $t('enum.E_ModelFaultTypeKind.NoWave')
 */
export enum E_ModelFaultTypeKind {
    /**
     * 转子类故障检测
     */
    RotorFailure = 'RotorFailure',
    /**
     * 轴承故障检测
     */
    BearingFailure = 'BearingFailure',
    /**
     * 齿轮故障检测
     */
    GearFailure = 'GearFailure',

    /**
     * 寿命预测
     */
    Durability = 'Durability',

    /**
     * 齿轮/轴承故障检测
     */
    GearBearingFailure = 'GearBearingFailure',


    
    /**
     * 停机数据
     */
    DownTimeData = 'DownTimeData',

    /**
     *  无波形
     */
    NoWave = 'NoWave',

}

/**
 * 图谱类型
 * $t('enum.E_MapType.NoFrequencyFaultCharacteristics')
 * $t('enum.E_MapType.FrequencyConversion1x')
 * $t('enum.E_MapType.FrequencyConversion1_2x')
 * $t('enum.E_MapType.FrequencyConversionHarmonic')
 * $t('enum.E_MapType.NoBearingFaultCharacteristics')
 * 
 * $t('enum.E_MapType.OuterRingFrequency')
 * $t('enum.E_MapType.InnerRingFrequency')
 * $t('enum.E_MapType.RollingElementFrequency')
 * $t('enum.E_MapType.NoGearFaultCharacteristics')
 * $t('enum.E_MapType.MeshingFrequencySideband') 
 * 
 * $t('enum.E_MapType.TimeDomainImpulse') 
 * $t('enum.E_MapType.NoTimeDomainImpulse')
 * 
 * 
 * $t('enum.E_MapType.Gearbox_OuterRingFrequency')
 * $t('enum.E_MapType.Gearbox_InnerRingFrequency')
 * $t('enum.E_MapType.Gearbox_RollingElementFrequency')
 * $t('enum.E_MapType.Gearbox_NoGearFaultCharacteristics')
 * $t('enum.E_MapType.Gearbox_MeshingFrequencySideband') 
 * 
 * $t('enum.E_MapType.Gearbox_TimeDomainImpulse') 
 * $t('enum.E_MapType.Gearbox_NoTimeDomainImpulse')
 * 
 * $t('enum.E_MapType.DownTimeData')
 * $t('enum.E_MapType.NoWave')
 * 
 * $t('enum.E_MapType.Durability')
 */
export enum E_MapType {
    /**
     * 无转频故障特征
     */
    NoFrequencyFaultCharacteristics = 1101,
    /**
     * 1倍转频
     */
    FrequencyConversion1x = 1102,
    /**
     * 1-2倍转频
     */
    FrequencyConversion1_2x = 1103,
    /**
     * 转频谐波
     */
    FrequencyConversionHarmonic = 1104,

    /**
     * 无故障特征
     */
    NoBearingFaultCharacteristics = 1201,
    /**
     * 外圈频率，
     */
    OuterRingFrequency = 1202,
    /**
     * 内圈频率，
     */
    InnerRingFrequency = 1203,
    /**
     * 滚动体频率，
     */
    RollingElementFrequency = 1204,
    /**
     * 无边带频率特征
     */
    NoGearFaultCharacteristics = 1301,
    /**
     * 边带频率特征
     */
    MeshingFrequencySideband = 1302,

    /**
     * 时域冲击特征
     */
    TimeDomainImpulse = 1401,
    /**
     * 无时域冲击特征
     */
    NoTimeDomainImpulse = 1402,


    // 齿轮箱    
     /**
     * 无齿轮故障特征
     */
    Gearbox_NoBearingFaultCharacteristics = 1501,
    /**
     * 齿轮外圈频率，
     */
    Gearbox_OuterRingFrequency = 1502,
    /**
     * 齿轮内圈频率，
     */
    Gearbox_InnerRingFrequency = 1503,
    /**
     * 齿轮滚动体频率，
     */
    Gearbox_RollingElementFrequency = 1504,
    /**
     * 齿轮无边带频率特征
     */
    Gearbox_NoGearFaultCharacteristics = 1601,
    /**
     * 齿轮边带频率特征
     */
    Gearbox_MeshingFrequencySideband = 1602,

    /**
     * 齿轮时域冲击特征
     */
    Gearbox_TimeDomainImpulse = 1701,
    /**
     * 齿轮无时域冲击特征
     */
    Gearbox_NoTimeDomainImpulse = 1702,
   
    /**
     * 停机数据
     */
    DownTimeData = 2001,

    /**
     *  无波形
     */
    NoWave = 2002,

    /**
     * 寿命预测
     */
    Durability = 1901,
}

export enum E_MapTypeStr {
    /**
     * 无转频故障特征
     */
    NoFrequencyFaultCharacteristics = '1101',
    /**
     * 1倍转频
     */
    FrequencyConversion1x = '1102',
    /**
     * 1-2倍转频
     */
    FrequencyConversion1_2x = '1103',
    /**
     * 转频谐波
     */
    FrequencyConversionHarmonic = '1104',

    /**
     * 无轴承故障特征
     */
    NoBearingFaultCharacteristics = '1201',
    /**
     * 外圈频率，
     */
    OuterRingFrequency = '1202',
    /**
     * 内圈频率，
     */
    InnerRingFrequency = '1203',
    /**
     * 滚动体频率，
     */
    RollingElementFrequency = '1204',
    /**
     * 无齿轮故障特征，
     */
    NoGearFaultCharacteristics = '1301',
    /**
     * 啮合频率边带
     */
    MeshingFrequencySideband = '1302',
    /**
     * 时域冲击特征
     */
    TimeDomainImpulse = '1401',
    /**
     * 无时域冲击特征
     */
    NoTimeDomainImpulse = '1402',

    // 齿轮箱    
     /**
     * 无轴承故障特征
     */
    Gearbox_NoBearingFaultCharacteristics = '1501',
    /**
     * 外圈频率，
     */
    Gearbox_OuterRingFrequency = '1502',
    /**
     * 内圈频率，
     */
    Gearbox_InnerRingFrequency = '1503',
    /**
     * 滚动体频率，
     */
    Gearbox_RollingElementFrequency = '1504',
    /**
     * 无边带频率特征
     */
    Gearbox_NoGearFaultCharacteristics = '1601',
    /**
     * 边带频率特征
     */
    Gearbox_MeshingFrequencySideband = '1602',

    /**
     * 时域冲击特征
     */
    Gearbox_TimeDomainImpulse = '1701',
    /**
     * 无时域冲击特征
     */
    Gearbox_NoTimeDomainImpulse = '1702',

    /**
     * 停机数据
     */
    DownTimeData = '2001',

    /**
     *  无波形
     */
    NoWave = '2002',

     /**
     * 寿命预测
     */
    Durability = '1901',
}

/**
 * 数据诊断来源
 */
export enum E_DiagnosisSourceType {
    /**
     * 在线监测
     */
    OnlineMonitor = 1,
    /**
     * 点检
     */
    InspectPoint = 2,
}

export interface IDiagnosisModelDeleteParams {
    id: number
}

export interface IDiagnosisModelItem {
    /**
     * 算法名称
     */
    algorithmName: string
    /**
     * 诊断模型FileId
     */
    diagnosisModelFileId: number
    /**
     * 诊断模型名称
     */
    diagnosisModelName: string
    /**
     * 图谱类别
     */
    mapType: E_MapType
    /**
     * 图谱类别代码
     */
    mapTypeCode: string
    /**
     * 备注
     */
    remark: string
}

export type IDiagnosisModelAddParams = IDiagnosisModelItem

export interface IDiagnosisModelDeleteDiagnosisModelHistoryParams {
    historyId: number
}

export interface IDiagnosisModelDetailHistoryItem {
    createTime
    fileId
    fileUrl
    id
    modelName
    remark
}

export interface IDiagnosisModelDetailHistoryParams {
    id: number
}

export type IDiagnosisModelDetailHistoryData = IDiagnosisModelDetailHistoryItem[]


export interface IDiagnosisModelEditParams {
    algorithmName: string
    id: number
    mapType: E_MapType
    mapTypeCode: string
}

export interface IDiagnosisModelUpdateModelParams {
    id: number
    diagnosisModelHistoryId: string
}


export interface IDiagnosisModelUploadParams {
    id: number
    diagnosisModelName: string
    diagnosisModelFileId: number
    remark: string
}

export interface IDiagnosisModelEditHistoryParams {
    id: number
    modelName: string
    remark: string
}



export type IDiagnosisModelFindPageParams = IPageParams & Partial<{
    algorithmName
    diagnosisModelId

    mapType
    mapTypeCode

    startTime
    endTime
    remark
}>

export interface IDiagnosisModelFindPageItem {
    algorithmName
    createTime
    diagnosisModelCreateTime
    diagnosisModelName
    id
    mapType
    mapTypeCode
    remark
}

export type IDiagnosisModelFindPageData = IPageData<IDiagnosisModelFindPageItem>



export interface IDiagnosisConclusionRepositorItem {
    /**
     * 部件类型
     */
    componentType: E_ModelPartial
    /**
     * 故障代码
     */
    faultCode: string
    /**
     * 诊断结论
     */
    faultConclusion: string
    /**
     * 诊断结论英文
     */
    faultConclusionEn: string
    /**
     * 故障类型
     */
    faultType: E_ModelFaultType
    /**
     * 故障类型(英文) 忽略
     */
    faultTypeEn?: string
    /**
     * 图谱类别
     */
    mapType: E_MapType
}

export interface IDiagnosisConclusionRepositorDeleteParams {
    id: number
}



export type IDiagnosisConclusionRepositorAddParams = IDiagnosisConclusionRepositorItem

export type IDiagnosisConclusionRepositorEditParams = WithId<IDiagnosisConclusionRepositorItem>

export type IDiagnosisConclusionRepositorListData = Array<IDiagnosisConclusionRepositorEditParams>



export interface IDiagnosisNewFindPageItem extends IAlarmDetail {
    companyName: string
    areaName: string
    diagnosisDTO: IDiagnosisNewDetailItem[]

    /**
     * 平台处理
     */
    diagnosisHandleId?: number
    /**
     * 维修单
     */
    repairId?: number
    repairStatus?: E_UpkeepRepairHandleStatus
    /**
     * 保养单
     */
    upkeepId?: number
    upkeepStatus?: E_UpkeepRepairHandleStatus
    sourceType: E_DiagnosisSourceType
}   


export type IDiagnosisNewFindPageParams = IPageParams & Partial<{
    companyId: number
    areaId: number
    equipmentId: number
    mappingId: number
    sensorId: string
    startTime: string
    endTime: string
}>

export type IDiagnosisNewFindPageData = IPageData<IDiagnosisNewFindPageItem>


export interface IDiagnosisNewDetailParams {
    diagnosisId: number | string
}

/**
 * 故障置信度
 */
export interface IDiagnosisDetailPercentageItem {
    diagnosisRatio: number
    diagnosisType: E_ModelFaultType

    diagnosisCode?: string
    mapType?: string
}

export interface IDiagnosisNewDetailItem {
    /**
     * 故障诊断结论代码
     */
    conclusionVOList: string[]
    diagnosisDetailPercentageVOList: IDiagnosisDetailPercentageItem[]

    /**
     * 诊断结果
     */
    diagnosisResult: string[]
}

export type IDiagnosisNewDetailData = IDiagnosisNewDetailItem
